
import ToolHeader from "../../Components/ToolHeader";
import "../JSONTools/JSONformatter.css";
import { Row, Col } from "react-bootstrap";
import "./ImagePdfTools.css";
import { useState, useRef } from "react";

import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import { PDFMergerAPI } from "../../Services/APIService";
import { ReactComponent as MoveUpIcon } from "../../Icons/shape-arrow-up.svg";
import { ReactComponent as MoveDownIcon } from "../../Icons/shape-arrow-down.svg";
import SplitPdf from "./SplitPdf";

const FORMAT_OPTIONS = [
    "Merge PDFs",
    "Split PDFs",
];

function PDFMergerSplitter() {
    const [selectedFormat, setSelectedFormat] = useState("Merge PDFs");
    const inputRef = useRef(null);

    const [pdfFiles, setPdfFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const handleDrop = (e) => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
    };
    const toolFav = {
        toolName: "PDF Merger & Splitter",
        Iconpath: "/FileCodeRaw.svg"
    };

    

    

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];
                resolve(base64);
            };

            reader.onerror = (error) => reject(error);
        });
    };

    // Handle File Upload
    const handleFiles = async (files) => {
        const fileArray = Array.from(files);

        const formattedFiles = await Promise.all(
            fileArray.map(async (file) => {
                const base64 = await convertToBase64(file);

                return {
                    id: Date.now() + Math.random(),
                    name: file.name,
                    size: (file.size / 1024).toFixed(1),
                    pages: 1,
                    base64,
                };
            })
        );

        setPdfFiles((prev) => [...prev, ...formattedFiles]);
    };

    // Move Up
    const moveUp = (index) => {
        if (index === 0) return;

        const updated = [...pdfFiles];

        [updated[index - 1], updated[index]] = [
            updated[index],
            updated[index - 1],
        ];

        setPdfFiles(updated);
    };

      const handleChange = (e) => {
        handleFiles(e.target.files);
    };

    // Move Down
    const moveDown = (index) => {
        if (index === pdfFiles.length - 1) return;

        const updated = [...pdfFiles];

        [updated[index + 1], updated[index]] = [
            updated[index],
            updated[index + 1],
        ];

        setPdfFiles(updated);
    };

    // Remove File
    const removeFile = (id) => {
        setPdfFiles((prev) => prev.filter((file) => file.id !== id));
    };

    // Merge API
    const handleMergeAndDownload = async () => {
        try {
            if (pdfFiles.length === 0) {
                alert("Please upload PDFs");
                return;
            }

            setLoading(true);

            const payload = {
                base64Pdfs: pdfFiles.map((file) => file.base64),
            };

            const response = await PDFMergerAPI(payload);

            const mergedBase64 = response.data.mergedBase64Pdf;

            // Download merged PDF
            const linkSource = `data:application/pdf;base64,${mergedBase64}`;

            const downloadLink = document.createElement("a");

            downloadLink.href = linkSource;
            downloadLink.download = "merged.pdf";

            downloadLink.click();

            alert(
                `${response.data.totalFilesMerged} files merged successfully in ${response.data.processingTimeMs} ms`
            );
        } catch (error) {
            console.error(error);
            alert("Failed to merge PDFs");
        } finally {
            setLoading(false);
        }
    };


    return (
        <Col>

            {/* HEADER */}
            <ToolHeader title="PDF Merger & Splitter" description="Merge, split PDFs in your browser" toolFav={toolFav} />

            {/* FORMAT TABS */}
            <Row>
                <div className="format-tabs">
                    {FORMAT_OPTIONS.map((item) => (
                        <button
                            key={item}
                            className={`format-btn ${selectedFormat === item
                                ? "active"
                                : ""
                                }`}
                            onClick={() => setSelectedFormat(item)}
                        >
                            {item}
                        </button>

                    ))}

                </div>

            </Row>

            <Row className='Formatter'>

                {selectedFormat === "Merge PDFs" && (
                    <div className="pdf-merger-container">
                        {/* Header */}
                        <div className="pdf-header">
                            <label>Merge PDFs</label>
                            <p>Combine multiple PDFs into one.</p>
                        </div>

                        {/* Upload Area */}
                       <div
                                className="upload-zone"
                                onClick={() => inputRef.current.click()}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                            >
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    ref={inputRef}
                                    accept={
                                        selectedFormat === "Image to PDF"
                                            ? "image/*"
                                            : ".pdf"
                                    }
                                    onChange={handleChange}
                                />

                                <div className="upload-icon">
                                  <svg
                                        className="dmc-upload-icon"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M12 16V4M12 4L7 9M12 4L17 9" />
                                        <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                                    </svg>
                                </div>

                                <p className="upload-text">
                                    Click to select or drop PDFs
                                    here
                                </p>

                                <span className="upload-subtext">
                                    {selectedFormat === "Image to PDF"
                                        ? "Each image becomes one PDF page, in the order shown"
                                        : "Each PDF page will be converted into an image"}
                                </span>
                            </div>

                        {/* PDF List */}
                        <div className="pdf-list">
                            {pdfFiles.map((file, index) => (
                                <div className="pdf-item" key={file.id}>
                                    {/* Left */}
                                    <div className="pdf-left">
                                        <div className="index-box">{index + 1}</div>

                                        <div className="pdf-icon">📄</div>

                                        <div>
                                            <div className="pdf-name">{file.name}</div>

                                            <div className="pdf-meta">
                                                {file.pages} pages • {file.size} KB
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right */}
                                    <div className="pdf-actions">
                                        <button onClick={() => moveUp(index)}>
                                            <MoveUpIcon  />
                                        </button>

                                        <button onClick={() => moveDown(index)}>
                                            <MoveDownIcon  />
                                        </button>

                                        <button
                                            className="delete-btn"
                                            onClick={() => removeFile(file.id)}
                                        >
                                            <DeleteIcon className="pdf-action-icon" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Footer */}
                        <div className="footer-section">
                            <div className="footer-left">
                                {pdfFiles.length} files •{" "}
                                {pdfFiles.reduce((acc, item) => acc + item.pages, 0)}{" "}
                                pages total
                            </div>

                            <button
                                className="ExecuteButton"
                                onClick={handleMergeAndDownload}
                                disabled={loading}
                            >
                                {loading ? "Merging..." : "↓ Merge & Download"}
                            </button>
                        </div>
                    </div>
                )}
                {selectedFormat === "Split PDFs" && (
                    <SplitPdf/>
                )}
            </Row>

        </Col>
    );
}

export default PDFMergerSplitter;

